import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [

    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '泰安市医师协会'
          }
        },
        {
          path: '/ArticleListPage/:id?/:subId?',
          name: 'ArticleListPage',
          redirect: '/ArticleListPage/ArticleList/:id?/:subId?/:recordId?',
          component: resolve => require(['@/view/ArticleListPage'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
          children: [
            {
              path: '/ArticleListPage/ArticleList/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/ArticleList'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            }

          ]
        }, {
          path: '/ArticlePage/:id?/:subId?/:recordId?',
          name: 'ArticlePage',
          component: resolve => require(['@/view/ArticlePage.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },

        {
          path: '/ImagePage/:id?/:subId?/:recordId?',
          name: 'ImagePage',
          component: resolve => require(['@/view/ImagePage.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },
        {
          path: '/ImageList/:id?/:subId?/:recordId?',
          name: 'ImageList',
          component: resolve => require(['@/view/ImageList.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },


        {
          path: '/MemberRegistered',
          name: 'MemberRegistered',
          component: resolve => require(['@/view/MemberRegistered.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },
        {
          path: '/VipListPage/:id?/:subId?',
          name: 'VipListPage',
          redirect: '/VipListPage/VipList/:id?/:subId?/:recordId?',
          component: resolve => require(['@/view/VipListPage'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
          children: [
            {
              path: '/VipListPage/VipList/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/VipList'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            }, {

              path: '/VipListPage/VipCertificateList/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/VipCertificateList'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            }
            , {

              path: '/VipListPage/AwardApplication/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/AwardApplication'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            },
            {

              path: '/VipListPage/OnlinePayment/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/OnlinePayment'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            },
            {

              path: '/VipListPage/VipDownload/:id?/:subId?/:recordId?',
              component: resolve => require(['@/view/VipDownload'], resolve),
              meta: {
                title: '泰安市医师协会'
              }
            }
          ]
        },
        {

          path: '/AwardApplicationPage/:id?/:recordId?',
          component: resolve => require(['@/view/AwardApplicationPage'], resolve),
          meta: {
            title: '泰安市医师协会'
          }
        },
        {
          path: '/Information/:id?/:subId?',
          name: 'Information',
          component: resolve => require(['@/view/Information.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },
        {
          path: '/SearchPage/:id',
          name: 'SearchPage',
          component: resolve => require(['@/view/SearchPage.vue'], resolve),
          meta: {
            title: '泰安市医师协会'
          },
        },
        {
          path: '/MeetingPage/:id?',
          name: 'MeetingPage',
          component: resolve => require(['@/view/MeetingPage.vue'], resolve),
          meta: {
            title: '在线签单系统'
          },
        }
        ,
        {
          path: '/ContactUs',
          name: 'ContactUs',
          component: resolve => require(['@/view/ContactUs.vue'], resolve),
          meta: {
            title: ''
          },
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js